import React from 'react';

import { Route, Routes as ReactRoutes, Navigate } from 'react-router-dom';

import { DetailsPage } from 'pages/DetailsPage';
import { HomePage } from 'pages/HomePage';
import { RequestPageSent } from 'pages/RequestSentPage/RequestPageSent';

import paths from './routesPaths';

const Routes: React.FC = () => {
  return (
    <ReactRoutes>
      <Route path={paths.root} element={<HomePage />} />
      <Route path={paths.apartment} element={<DetailsPage />} />
      <Route path={paths.requestSent} element={<RequestPageSent />} />
      <Route path='*' element={<Navigate to={paths.root} replace />} />
    </ReactRoutes>
  );
};

export default React.memo(Routes);
